import {
  Component,
  Inject,
  OnDestroy,
  OnInit
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CountryService, Country } from "../../../../../swaggerServices";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormGroup,
  AbstractControl
} from "@angular/forms";
import { TenantConfigService } from "../../../../shared/services/tenant-config.service";
import { ConfigStateService } from "../../../config/config-state.service";
import { TranslocoService } from "@jsverse/transloco";

@Component({
    selector: "app-add-update-country",
    templateUrl: "./add-update-country.component.html",
    styleUrls: ["./add-update-country.component.scss"],
    standalone: false
})
export class AddUpdateCountryComponent implements OnInit, OnDestroy {
  country: Country;

  form: UntypedFormGroup;
  isCreate: boolean = false;

  uiConfig: TenantConfigService;
  countryAlias: string;

  private unsubscribe = new Subject<void>();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private countryService: CountryService,
    private config: ConfigStateService,
    private translocoService: TranslocoService,
    private dialogRef: MatDialogRef<AddUpdateCountryComponent>,
    @Inject(MAT_DIALOG_DATA) country: Country
  ) {
    this.country = country;
  }

  get countryCode(): AbstractControl {
    return this.form.get("countryCode");
  }

  get countryName(): AbstractControl {
    return this.form.get("countryName");
  }

  ngOnInit() {
    this.isCreate = !this.country;
    this.initForm();
    this.config.loadConfig().subscribe(config => {
      this.uiConfig = new TenantConfigService(config);
      this.countryAlias = this.uiConfig.config.countryAlias;
      this.translocoService
        .selectTranslate("country-alias")
        .subscribe(value => (this.countryAlias = value));
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  save() {
    if (this.isCreate) {
      const postData = {
        countryCode: this.countryCode.value,
        countryName: this.countryName.value
      };
      this.countryService
        .addCountry(postData)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          result => {
            this.dialogRef.close(true);
          },
          error => {
            this.dialogRef.close(false);
          }
        );
    } else {
      const postData = {
        id: this.country.id || null,
        countryCode: this.countryCode.value,
        countryName: this.countryName.value
      };
      this.countryService
        .updateCountry(postData)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          result => {
            this.dialogRef.close(true);
          },
          error => {
            this.dialogRef.close(false);
          }
        );
    }
  }

  onClose() {
    this.dialogRef.close(false);
  }

  formatter(option) {
    return option.label;
  }

  private initForm() {
    this.form = this.formBuilder.group({
      countryCode: ["", Validators.required],
      countryName: ["", Validators.required]
    });

    if (!this.isCreate) {
      this.countryCode.setValue(this.country.countryCode);
      this.countryName.setValue(this.country.countryName);
    }
  }
}
